/**
 * Event announcement -- copy the coupon code.
 * See docs/modules/event_announcement.md#copy
 */

const JB_COPY_REVERT_MS = 2000;

/**
 * navigator.clipboard is undefined on an insecure origin, which is every local
 * http host -- so the deprecated execCommand path is the one that actually runs
 * in development, not a rare fallback.
 */
const jbCopyText = async (text) => {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            // permission denied or a non-focused document; fall through
        }
    }

    const scratch = document.createElement('textarea');

    scratch.value = text;
    scratch.setAttribute('readonly', '');
    /**
     * Inside the viewport, not off-screen. select() scrolls the element into
     * view, so a textarea parked at top:-9999px drags the page to the top --
     * see docs/modules/event_announcement.md#copy
     */
    scratch.style.cssText =
        'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;pointer-events:none;';
    document.body.appendChild(scratch);

    // belt and braces: the smoother and the window can be restored independently
    const smoother = window.DRG?.smoother;
    const smootherTop = smoother ? smoother.scrollTop() : null;
    const windowTop = window.scrollY;

    scratch.select();

    let copied = false;

    try {
        copied = document.execCommand('copy');
    } catch {
        copied = false;
    }

    scratch.remove();

    if (window.scrollY !== windowTop) window.scrollTo(0, windowTop);
    if (smoother && smoother.scrollTop() !== smootherTop) smoother.scrollTop(smootherTop);

    return copied;
};

document.addEventListener('click', async (event) => {
    const trigger = event.target.closest?.('[data-jb-copy]');

    if (!trigger || trigger.dataset.jbCopyBusy) return;

    const code = trigger.dataset.jbCopy;

    if (!code) return;

    const copied = await jbCopyText(code);

    if (!copied) return;

    const label = trigger.querySelector('span');

    if (!label) return;

    // the width is pinned before the swap so the row cannot reflow mid-interaction
    trigger.style.minWidth = `${trigger.offsetWidth}px`;
    trigger.dataset.jbCopyBusy = '1';

    const original = label.textContent;

    label.textContent = trigger.dataset.jbCopyLabel || 'Copied';

    window.setTimeout(() => {
        label.textContent = original;
        delete trigger.dataset.jbCopyBusy;
        trigger.style.minWidth = '';
    }, JB_COPY_REVERT_MS);
});
